@if (media.mediaType === MediaType.Audio && listView) {
	<sim-media-card-list
		[media]="media"
		[showFileTypeIcon]="false"
		[active]="media.id === mediaPlayer?.info?.currentMedia?.mediaId && mediaPlayer?.info?.currentMedia?.isPlaying"
		(mediaClicked)="mediaClicked()"
		[progress]="progressFromDisplayedMedia(mediaPlayer?.info?.currentMedia)"
		[mediaPlayer]="mediaPlayer"
	/>
}

@if (media.mediaType === MediaType.Audio && !listView) {
	<div
		class="mediaCard"
		[class.active]="media.id === mediaPlayer?.info?.currentMedia?.mediaId && mediaPlayer?.info?.currentMedia?.isPlaying"
		(click)="mediaClicked()"
	>
		<div class="mediaHeader">
			<mat-icon class="mediaIcon" fontSet="fad" fontIcon="fa-file-audio" inline />
			<div class="controlsContainer">
				<button
					mat-mini-fab
					color="accent"
					class="mediaPlayButton"
					[disabled]="mediaPlayer?.webSocket?.activityState === ActivityState.Inactive"
				>
					<sim-animated-material-icon
						[trigger]="media.id === mediaPlayer?.info?.currentMedia?.mediaId && mediaPlayer?.info?.currentMedia?.isPlaying"
						[endIcon]="{
							fontSet: 'fad',
							fontIcon: 'fa-pause',
							themeColor: 'accent',
						}"
						[startIcon]="{
							fontSet: 'fad',
							fontIcon: 'fa-play',
							themeColor: 'white',
						}"
					/>
				</button>
			</div>
		</div>
		<div class="mediaText">
			<div class="title">{{ media.name }}</div>
			<div class="description">{{ media.fileName }}</div>
		</div>
	</div>
}
